import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const UrlLanguageCleaner: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const urlParams = new URLSearchParams(location.search);
		const langParam = urlParams.get('lang');

		// If lang parameter exists and is valid, clean it up from URL
		if (langParam && ['en', 'et'].includes(langParam)) {
			urlParams.delete('lang');
			const newSearch = urlParams.toString();
			const newPath = location.pathname + (newSearch ? `?${newSearch}` : '');
			
			// Replace the current URL without the lang parameter
			navigate(newPath, { replace: true });
		}
	}, [location.search, navigate, location.pathname]);

	return null; // This component doesn't render anything
};

export default UrlLanguageCleaner;